import { render, staticRenderFns } from "./ActiveSign.vue?vue&type=template&id=445f52ee&"
import script from "./ActiveSign.vue?vue&type=script&lang=js&"
export * from "./ActiveSign.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445f52ee')) {
      api.createRecord('445f52ee', component.options)
    } else {
      api.reload('445f52ee', component.options)
    }
    module.hot.accept("./ActiveSign.vue?vue&type=template&id=445f52ee&", function () {
      api.rerender('445f52ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/agile/ActiveSign.vue"
export default component.exports